import React, {createContext, ReactNode, useState} from 'react';
import {ConfirmModal, ConfirmModalProps} from 'components/common';

type showModalArgs = {
  message: string;
  onConfirmHandler: () => void;
  header?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
};
export type ConfirmModalContextType = {
  showModal: (args: showModalArgs) => void;
};
const ConfirmModalContext = createContext<ConfirmModalContextType>({
  showModal: () => {},
});
const Provider = ConfirmModalContext.Provider;

export const ConfirmationModalProvider: React.FC<{children: ReactNode}> = ({
  children,
}) => {
  const [modalData, setModalData] = useState<Omit<
    ConfirmModalProps,
    'onClose' | 'visible'
  > | null>(null);

  const defaultCancelText = 'No';
  const defaultConfirmText = 'Yes';

  function showModal({
    message,
    onConfirmHandler,
    cancelButtonText = defaultCancelText,
    confirmButtonText = defaultConfirmText,
    header = '',
  }: showModalArgs) {
    setModalData(p => ({
      header,
      message,
      cancelButtonText,
      confirmButtonText,
      onConfirm: onConfirmHandler,
    }));
  }

  function handleClose() {
    setModalData(null);
  }

  return (
    <Provider
      value={{
        showModal,
      }}>
      {children}
      {modalData && (
        <ConfirmModal
          visible={Boolean(modalData)}
          header={modalData?.header}
          message={modalData?.message}
          onClose={handleClose}
          onConfirm={modalData?.onConfirm}
          cancelButtonText={modalData?.cancelButtonText}
          confirmButtonText={modalData?.confirmButtonText}
        />
      )}
    </Provider>
  );
};

export default ConfirmModalContext;
